// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { useContext } from "react";
import styled from "styled-components";

import { UsTnReclassificationReviewForm } from "../../../../WorkflowsStore/Opportunity/Forms/UsTnReclassificationReviewForm";
import { FormViewerContext } from "../../FormViewer";
import { useOpportunityFormContext } from "../../OpportunityFormContext";
import { PrintablePage } from "../../styles";
import FormInput from "./FormInput";
import { FormContainer } from "./styles";

const Container = styled.div`
  font-family: monospace;

  textarea {
    width: 100%;
  }
`;

const Headline = styled.div`
  text-align: center;
`;

const Row = styled.div<{ indented?: boolean; grouped?: boolean }>`
  width: 95%;
  margin-left: ${({ indented }) => (indented ? "2em" : 0)};
  margin-top: ${({ grouped }) => (grouped ? 0 : "5em")};
`;

const SigRow = styled.div`
  display: flex;
  margin-top: 5em;
  width: 95%;
`;

const SigColumn = styled.div`
  flex-grow: 1;

  &:not(:last-child) {
    margin-right: 2em;
  }
`;

const DateColumn = styled(SigColumn)`
  flex-grow: 0;
  width: 12em;
`;

const SigLine = styled.div`
  border-bottom: 0.5px solid black;
  margin-bottom: 0.5em;
`;

const HearingNotice = ({
  pilotVersion = false,
}: {
  pilotVersion?: boolean;
}) => {
  const { formData } =
    useOpportunityFormContext() as UsTnReclassificationReviewForm;
  const formViewerContext = useContext(FormViewerContext);

  return (
    <PrintablePage>
      <FormContainer {...formViewerContext}>
        <Container>
          <Headline>TENNESSEE DEPARTMENT OF CORRECTION</Headline>
          <Headline>CLASSIFICATION HEARING NOTICE</Headline>
          <Row>
            TOMIS ID: {formData.omsId} {formData.residentFullName}
          </Row>
          <Row grouped>CAF Date: {formData.date}</Row>
          <Row>
            This is to inform you that your classification hearing will be held
            on <FormInput name="hearingDate" placeholder="hearing date" /> at{" "}
            <FormInput name="hearingLocation" placeholder="hearing location" />.
          </Row>
          <Row>
            Classification Type:{" "}
            {pilotVersion ? formData.classificationType : "CL CLASSIFICATION"}
          </Row>
          <SigRow>
            <SigColumn>
              <SigLine>x</SigLine>
              Offender Signature
            </SigColumn>
            <DateColumn>
              <SigLine>&nbsp;</SigLine>
              Date
            </DateColumn>
          </SigRow>
        </Container>
      </FormContainer>
    </PrintablePage>
  );
};

export default HearingNotice;
